<mat-sidenav-container class="sidenav-container">
	<mat-sidenav #sideNav class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
		<div fxLayout="column" [ngClass]="{ 'text-black': app === 'Y-Stop', 'text-white': app !== 'Y-Stop' }" style="height: 100%">
			<mat-toolbar *ngIf="app !== 'Jotto'" color="primary" class="app-toolbar">
				<div class="toolbar-logo">
					<img src="/assets/images/logo-white.png" />
				</div>
			</mat-toolbar>
			<div *ngIf="multiProject && !(isTablet$ | async)" class="dashboard-image bg-portals-theme-primary text-center">
				<div class="image-border" [ngClass]="{ 'border-2 border-solid border-portals-theme-accent': app === 'Jotto' }">
					<img [routerLink]="['settings', 'project']" [ngStyle]="{ 'border-radius': app == 'Jotto' ? '50%' : null }" [src]="dashboardImage" />
				</div>
				<h3 class="project-name font-extrabold" matLine>{{ projectName }}</h3>
			</div>
			<div *ngIf="multiProject && (isTablet$ | async)" class="w-[129px] h-[129px]"></div>
			<mat-nav-list class="overflow-y-auto py-3 px-3 h-full">
				<ul class="pt-3 pb-2 space-y-2">
					<ng-container *ngFor="let item of menu">
						<li fxLayout="row">
							<ng-container *ngIf="item.routerLink">
								<a
									[matTooltip]="(isTablet$ | async) ? item.text : ''"
									matTooltipClass="custom-tooltip"
									matTooltipPosition="right"
									[tourAnchor]="item.anchorId ? item.anchorId : ''"
									*ngIf="'manage' | able : item.text.toLowerCase()"
									[routerLink]="item.routerLink"
									routerLinkActive="--active"
									[ngClass]="{ 'text-black': app === 'Y-Stop', 'text-white': app !== 'Y-Stop' }"
									class="menu-item flex items-center p-2 font-normal text-gray-900 rounded-lg transition duration-75 group cursor-pointer"
									class.--active="text-portals-primary-text"
									i
								>
									<ng-container *ngIf="item.icon">
										<fa-icon [icon]="item.icon" [class]="item.customClass ? item.customClass : ''" class="far menu-icon font-icon transition duration-75 flex-shrink-0 w-6 h-6" flex="10"></fa-icon>
									</ng-container>
									<ng-container *ngIf="item.svg">
										<svg aria-hidden="true" flex="10" [class]="item.customClass ? item.customClass : ''" class="menu-icon flex-shrink-0 w-5 h-5 mr-0 transition duration-75" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" [innerHTML]="sanitizeSVG(item.svg)"></svg>
									</ng-container>

									<span [class]="item.customClass ? item.customClass : ''" class="ml-3">{{ item.text }}</span>
								</a>
							</ng-container>
							<ng-container *ngIf="item.function">
								<a *ngIf="'manage' | able : item.text.toLowerCase()" (click)="executeFunction(item.function)" [matTooltip]="(isTablet$ | async) ? item.text : ''" matTooltipClass="custom-tooltip" matTooltipPosition="right" routerLinkActive="--active" [ngClass]="{ 'text-black': app === 'Y-Stop', 'text-white': app !== 'Y-Stop' }" class="menu-item flex items-center p-2 font-normal text-gray-900 rounded-lg transition duration-75 group cursor-pointer" class.--active="text-portals-primary-text">
									<ng-container *ngIf="item.icon">
										<fa-icon [icon]="item.icon" [class]="item.customClass ? item.customClass : ''" class="far menu-icon font-icon transition duration-75 flex-shrink-0 w-6 h-6 cursor-pointer" flex="10"></fa-icon>
									</ng-container>
									<ng-container *ngIf="item.svg">
										<svg aria-hidden="true" flex="10" [class]="item.customClass ? item.customClass : ''" class="menu-icon flex-shrink-0 w-5 h-5 mr-0 transition duration-75 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" [innerHTML]="sanitizeSVG(item.svg)"></svg>
									</ng-container>

									<span [class]="item.customClass ? item.customClass : ''" class="ml-3">{{ item.function }}</span>
								</a>
							</ng-container>
						</li>
					</ng-container>
				</ul>
				<ul *ngIf="subMenu.length > 0" class="pt-3 mt-0 space-y-2 border-t border-gray-200 dark:border-gray-700" [ngClass]="{ 'text-black': app === 'Y-Stop', 'text-white': app !== 'Y-Stop' }">
					<ng-container *ngFor="let subItem of subMenu">
						<li>
							<ng-container *ngIf="subItem.routerLink">
								<a [routerLink]="subItem.routerLink" routerLinkActive="--active" [ngClass]="{ 'text-black': app === 'Y-Stop', 'text-white': app !== 'Y-Stop' }" class="menu-item flex items-center p-2 font-normal text-gray-900 rounded-lg transition duration-75 group" class.--active="text-portals-primary-text">
									<ng-container *ngIf="subItem.icon">
										<fa-icon [icon]="subItem.icon" [class]="subItem.customClass ? subItem.customClass : ''" class="far menu-icon font-icon transition duration-75 flex-shrink-0 w-6 h-6" flex="10"></fa-icon>
									</ng-container>
									<ng-container *ngIf="subItem.svg">
										<svg aria-hidden="true" [class]="subItem.customClass ? subItem.customClass : ''" class="menu-icon flex-shrink-0 w-5 h-5 transition duration-75" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" [innerHTML]="sanitizeSVG(subItem.svg)"></svg>
									</ng-container>

									<span [class]="subItem.customClass ? subItem.customClass : ''" class="ml-3">{{ subItem.text }}</span>
								</a>
							</ng-container>
							<ng-container *ngIf="subItem.function">
								<a (click)="executeFunction(subItem.function)" routerLinkActive="--active" [ngClass]="{ 'text-black': app === 'Y-Stop', 'text-white': app !== 'Y-Stop' }" class="menu-item flex items-center p-2 font-normal text-gray-900 rounded-lg transition duration-75 group" class.--active="text-portals-primary-text">
									<ng-container *ngIf="subItem.icon">
										<fa-icon [icon]="subItem.icon" [class]="subItem.customClass ? subItem.customClass : ''" class="far menu-icon font-icon transition duration-75 flex-shrink-0 w-6 h-6" flex="10"></fa-icon>
									</ng-container>
									<ng-container *ngIf="subItem.svg">
										<svg aria-hidden="true" [class]="subItem.customClass ? subItem.customClass : ''" class="menu-icon flex-shrink-0 w-5 h-5 transition duration-75" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" [innerHTML]="sanitizeSVG(subItem.svg)"></svg>
									</ng-container>

									<span [class]="subItem.customClass ? subItem.customClass : ''" class="ml-3">{{ subItem.text }}</span>
								</a>
							</ng-container>
						</li>
					</ng-container>
				</ul>
			</mat-nav-list>
			<span fxFlex></span>
			<div *ngIf="app !== 'Jotto'" class="sidenav-footer">
				<a href="https://quadrant2.us/" target="_blank">
					<img src="assets/images/company-logo-white.png" />
				</a>
			</div>
			<div *ngIf="app == 'Jotto'" class="jotto-footer flex justify-between align-items-center">
				<a href="https://jotto.ai/" target="_blank">
					<img class="jotto-image" src="/assets/images/logo-white.png" />
				</a>
			</div>
		</div>
	</mat-sidenav>
	<mat-sidenav-content>
		<mat-toolbar color="primary" class="content-toolbar">
			<button [disableRipple]="true" type="button" aria-label="Toggle sidenav" mat-icon-button (click)="sideNav.toggle()" *ngIf="isHandset$ | async">
				<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
			</button>
			<button [disableRipple]="true" type="button" aria-label="Go Back" mat-icon-button (click)="back()" *ngIf="enableBackButton">
				<mat-icon aria-label="Back Button">arrow_back</mat-icon>
			</button>
			<span>{{ titleService.getTitle() }}</span>
			<span fxFlex></span>
		</mat-toolbar>
		<ng-content></ng-content>
	</mat-sidenav-content>

	<mat-sidenav class="sidenav --right" #rightDrawer mode="over" position="end">
		<ng-template [cdkPortalOutlet]="drawer.content$ | async"></ng-template>
	</mat-sidenav>
</mat-sidenav-container>
